/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Closed_NowInputs */

const en_contact_closed_now = /** @type {(inputs: Contact_Closed_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed right now`)
};

const pl_contact_closed_now = /** @type {(inputs: Contact_Closed_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teraz zamknięte`)
};

/**
* | output |
* | --- |
* | "Closed right now" |
*
* @param {Contact_Closed_NowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_closed_now = /** @type {((inputs?: Contact_Closed_NowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Closed_NowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_closed_now(inputs)
	return en_contact_closed_now(inputs)
});